import { useNavigate } from "react-router";

import { useBookCoachMutation } from "@/graphql";

import { ScheduleState } from "./use-schedule-state";

interface CreateOrderParams {
  coachId: string;
  state: ScheduleState;
  onError: (message: string | null) => void;
  workspaceId?: string;
}

export function useBookCoach() {
  const navigate = useNavigate();
  const [bookCoach, { loading }] = useBookCoachMutation({
    update: (cache) => {
      cache.evict({ fieldName: "currentUser" });
      cache.evict({ fieldName: "introMeeting" });
      cache.evict({ fieldName: "assignments" });
      cache.evict({ fieldName: "customer" });
      cache.evict({ fieldName: "coachingPrograms" });

      cache.gc();
    },
  });

  const handleBooking = async ({
    coachId,
    state,
    onError,
  }: CreateOrderParams) => {
    const timeslotsStrings = state.selectedTimeslots.map((timeslot) => {
      const isPreferred = state.preferredTimeslots.includes(timeslot);
      return `${timeslot},${isPreferred ? "True" : "False"}`;
    });

    try {
      const result = await bookCoach({
        variables: {
          key: "",
          coachId,
          productQuantities: {
            [state.selectedProduct?.id || ""]: 1,
          },
          startTime: state.selectedTimeslots[0],
          customerId: state.selectedClientId,
          timeslotsStrings,
          usedAllTimeslot: state.showAllTimes,
          programComponentId:
            state.selectedSession && state.tab === "program"
              ? state.selectedSession.id
              : undefined,
        },
      });

      if (result.data?.createOrder?.error) {
        onError(result.data.createOrder.error.message ?? null);
      } else {
        navigate(
          `/checkout/${result.data?.createOrder?.order?.id}/next-steps`,
          { replace: true },
        );
      }
    } catch {
      onError(
        "We could not process your request at this time. Please contact us.",
      );
    }
  };

  return { handleBooking, loading };
}
